/*
 * Exports
 */
export { default } from './components/ItemLevelHoldsWorkflowView.component';
export { default as ItemLevelHoldsWorkflowTitle } from './components/ItemLevelHoldsWorkflowTitle.component';



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/item-level-holds-workflow-view/index.js